// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__jtLUk","page":"Layout_page__HeeB+"};